import {useTranslation} from 'react-i18next';
import {formatMoney} from '../../money';

type Props = {
  chargeTotal: number;
  holdTotal: number;
  isAuthorisation: boolean;
  currencySymbol: string;
};

function PaymentAmounts({
  chargeTotal,
  holdTotal,
  isAuthorisation,
  currencySymbol,
}: Props) {
  const {t} = useTranslation();

  if (chargeTotal <= 0 && holdTotal <= 0) return null;

  return (
    <div className="flex gap-2 [@container(min-width:720px)]:flex-col">
      {chargeTotal > 0 && (
        <span className="flex min-w-0 flex-1 flex-col gap-px rounded-[12px] bg-[var(--chekin-color-brand-navy)] px-3 py-[9px] text-[var(--chekin-color-white)] [@container(min-width:720px)]:flex-row [@container(min-width:720px)]:items-center [@container(min-width:720px)]:justify-between [@container(min-width:720px)]:px-3.5 [@container(min-width:720px)]:py-2.5">
          <small className="text-[12px] leading-4 text-white/80">
            {t('pay_flow.charged_now')}
          </small>
          <b className="text-[16px] font-bold leading-[22px] tabular-nums">
            {formatMoney(chargeTotal, currencySymbol)}
          </b>
        </span>
      )}
      {holdTotal > 0 && (
        <span className="flex min-w-0 flex-1 flex-col gap-px rounded-[12px] bg-[var(--chekin-color-white)] px-3 py-[9px] text-[var(--chekin-color-brand-navy)] outline-dashed outline-[1.5px] -outline-offset-[1.5px] outline-[var(--chekin-blue-300)] [@container(min-width:720px)]:flex-row [@container(min-width:720px)]:items-center [@container(min-width:720px)]:justify-between [@container(min-width:720px)]:px-3.5 [@container(min-width:720px)]:py-2.5">
          <small className="text-[12px] leading-4 text-[var(--chekin-text-secondary)]">
            {t(
              isAuthorisation
                ? 'pay_flow.authorised_not_charged'
                : 'pay_flow.held_not_charged',
            )}
          </small>
          <b className="text-[16px] font-bold leading-[22px] tabular-nums">
            {formatMoney(holdTotal, currencySymbol)}
          </b>
        </span>
      )}
    </div>
  );
}

export {PaymentAmounts};
